import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useLanguage } from "@/context/LanguageContext";
import { auctionsLabels } from "@/i18n";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

const pillTriggerClass =
  "native-scroll-chip shrink-0 rounded-full border border-border bg-background text-foreground text-[13px] font-medium whitespace-nowrap px-3 shadow-none data-[state=active]:border-primary data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-none";

export const MyAuctionsFilterTabs = () => {
  const { language } = useLanguage();
  const tabs = auctionsLabels(language).myAuctions.tabs;
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="native-scroll-chips native-orders-tab-chips w-full max-w-full mb-2 flex justify-center">
        <TabsList
          className={cn(
            "native-scroll-chips-track h-auto w-max max-w-none gap-2 bg-transparent p-0 shadow-none mx-auto",
          )}
        >
          <TabsTrigger value="all" className={pillTriggerClass}>
            {tabs.all}
          </TabsTrigger>
          <TabsTrigger value="auction" className={pillTriggerClass}>
            {tabs.auctions}
          </TabsTrigger>
          <TabsTrigger value="direct-purchase" className={pillTriggerClass}>
            {tabs.directPurchase}
          </TabsTrigger>
        </TabsList>
      </div>
    );
  }

  return (
    <TabsList
      className={`inline-flex items-center gap-1 backdrop-blur bg-secondary/50 text-[10px] sm:text-sm`}
    >
      <TabsTrigger
        value="all"
        className="text-[10px] sm:text-sm whitespace-nowrap py-1.5 sm:py-2 px-2 sm:px-3 data-[state=active]:bg-accent data-[state=active]:text-black"
      >
        {tabs.all}
      </TabsTrigger>
      <TabsTrigger
        value="auction"
        className="text-[10px] sm:text-sm whitespace-nowrap py-1.5 sm:py-2 px-2 sm:px-3 data-[state=active]:bg-accent data-[state=active]:text-black"
      >
        {tabs.auctions}
      </TabsTrigger>
      <TabsTrigger
        value="direct-purchase"
        className="text-[10px] sm:text-sm whitespace-nowrap py-1.5 sm:py-2 px-2 sm:px-3 data-[state=active]:bg-accent data-[state=active]:text-black"
      >
        {tabs.directPurchase}
      </TabsTrigger>
    </TabsList>
  );
};
